export default function useEnv() {
	return (key) => {
		return process.env['VUE_APP_' + key]
	}
}
